export enum BusinessActions {
  EDIT_DIALOG = 'edit_dialog',
}
